import { render, staticRenderFns } from "./diagnostic-report.vue?vue&type=template&id=77c6d693&"
import script from "./diagnostic-report.vue.js?vue&type=script&lang=js&"
export * from "./diagnostic-report.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports